import { encodeString, escapeQuotes } from '../../../services/root/root-service'

import filterQuery from '../../../services/filterQuery-service'
import { UsersFilterState } from '../components/types'

const prepareQuery = (filterState: UsersFilterState) => {
  const queryParams = []
  const { organizationName, roleName, email } = filterState

  const encodedOrganizationName = encodeString(
    escapeQuotes(organizationName?.trim())
  )
  const encodedEmail = encodeString(escapeQuotes(email?.trim()))

  if (encodedOrganizationName) {
    queryParams.push(
      filterQuery.getQueryString(
        `*${encodedOrganizationName}*`,
        filterQuery.templates.default,
        'organizationName',
        'contains'
      )
    )
  }

  if (encodedEmail) {
    queryParams.push(
      filterQuery.getQueryString(
        `*${encodedEmail}*`,
        filterQuery.templates.default,
        'email',
        'contains'
      )
    )
  }

  if (roleName) {
    queryParams.push(
      filterQuery.getQueryString(
        roleName,
        filterQuery.templates.default,
        'roleName',
        'eq'
      )
    )
  }

  const queryForFilter = filterQuery.createQueryStringFromArray(
    queryParams,
    'and'
  )

  return queryParams.length ? `query=${queryForFilter}&` : ''
}

export { prepareQuery }
